<template>
  <CollectionsListEx type="categories" :show-files="false" :show-kpis="true" title="Categories Collections" description="Conversation categories in your account. You can create multiple categories and then define different KPIs for different categories, for samples 'Sales Conversatons' and 'Support Conversations'"></CollectionsListEx>
</template>
<script setup>
  import CollectionsListEx from '@/components/Collections/CollectionsListEx.vue';
</script>
